import ServerCall from "./ServerCall";

// Codigos -2..-6 son fallas internas del backend (NAS, Bosnet, integracion, python).
// Mostramos un mensaje generico al usuario en lugar de exponer detalles tecnicos.
const FRIENDLY_BACKEND_ERROR = "Servicio temporalmente no disponible. Intentalo en unos minutos.";
const TECHNICAL_ERROR_CODES = new Set([-2, -3, -4, -5, -6]);

const normalizeError = (error) => {
    const data = error?.response?.data;
    if (data && typeof data === "object") {
        if (typeof data.code !== "undefined") {
            const code = Number(data.code);
            const message = TECHNICAL_ERROR_CODES.has(code)
                ? FRIENDLY_BACKEND_ERROR
                : data.message || "Error inesperado.";
            return { code: data.code, message };
        }
        if (data.error) {
            return { code: "AUTH", message: data.error };
        }
    }
    return { code: "NETWORK", message: "No se pudo establecer comunicacion con el servidor." };
};

const SoftphoneController = {
    getSoftphoneQR: async ({ contrato, cuenta, token }) => {
        try {
            const response = await ServerCall.get(
                "/telefonia/softphone/qr",
                token,
                { contrato },
                { cuenta }
            );
            return response;
        } catch (error) {
            throw normalizeError(error);
        }
    },
    getSoftphoneLink: async ({ contrato, cuenta, token }) => {
        try {
            const response = await ServerCall.get(
                "/telefonia/softphone/link",
                token,
                { contrato },
                { cuenta }
            );
            return response;
        } catch (error) {
            throw normalizeError(error);
        }
    },
};

export default SoftphoneController;
